import moment from 'moment'
import APIS from '../../constant/EndPoint';
import useGetHook from '../../customHooks/useGetHook';

const OrderHistory = ({ selectedOrder }: any) => {
  const { data: remarks } = useGetHook({
    queryKey: [`remakrs-${selectedOrder}`],
    url: APIS.REMARK,
    params: {
      limit: 200,
      offset: 0,
      order: selectedOrder
    },
  });
  const { data: orderHistory } = useGetHook({
    queryKey: [`order-hsitory-${selectedOrder}`],
    url: APIS.ORDER_HISTORY,
    params: {
      limit: 200,
      offset: 0,
      order: selectedOrder
    },
  });

  const { data:order } = useGetHook({
    queryKey: [`order-${selectedOrder}`],
    url: `${APIS.ORDER}${selectedOrder}/`,
    params: {},
  });

  return (
    <>
      <div className='flex justify-around text-3xl font-bold'>
        <div className='text-sm md:text-2xl'>{order?.pickup_branch?.name}</div>
        <div className='text-sm md:text-2xl'>---------</div>
        <div className='text-sm md:text-2xl'>{order?.destination?.name}</div>
      </div>
      <div className='flex justify-between mt-6'>
        <div>
          <div className='md:text-2xl font-semibold'>
            Consignment Details
          </div>
          <div className='text-xs md:text-lg'>
            <p>Waybill: {order?.tracking_number}</p>
            <p>COD: {order?.cod}</p>
            <p>Weight: {order?.total_weight} Kgs</p>
          </div>
        </div>
        <div>
          <div className='md:text-2xl font-semibold'>
            Sender
          </div>
          <div className='text-xs md:text-lg'>
            <p className='capitalize'>Name: {order?.sender_full_name?? order?.merchant?.name}</p>
            <p>Phone: <a href={`tel:${order?.sender_mobile_number?? order?.merchant?.mobile_number}`} className="text-xs text-gray-500 block">{order?.sender_mobile_number?? order?.merchant?.mobile_number}</a></p>
            <p>Location: {"N/A"}</p>
          </div>
        </div>
        <div>
          <div className='md:text-2xl font-semibold'>
            Receiver
          </div>
          <div className='text-xs md:text-lg'>
            <p>Name: {order?.customer_full_name}</p>
            <p>Phone: <a href={`tel:${order?.customer_mobile_number1}`} className="text-xs text-gray-500 block">{order?.customer_mobile_number1}</a></p>
            <p>Location: {order?.customer_full_address}</p>
          </div>
        </div>
      </div>

      <div className='grid grid-cols-1 md:grid-cols-2  mt-6 text-2xl font-semibold'>
        <div className='order-last md:order-first'>
          <div className='text-sm md:text-xl'>Consignment History</div>
          <div>
            <div className="flex flex-col md:grid text-gray-50 mt-6">
              {orderHistory?.results?.map((item: any, index: number) => (
                <div className="flex md:contents" key={index}>
                  <div className="col-start-2 col-end-4 mr-10 md:mx-auto relative">
                    <div className="h-full w-6 flex items-center justify-center">
                      <div className="h-full w-1 bg-green-500 pointer-events-none"></div>
                    </div>
                    <div className="w-6 h-6 absolute top-1/2 -mt-3 rounded-full bg-green-500 shadow text-center">
                      <i className="fas fa-check-circle text-white"></i>
                    </div>
                  </div>
                  <div className="bg-green-500 col-start-4 col-end-12 p-4 rounded-xl my-4 mr-auto shadow-md w-full">
                    <h3 className="font-semibold text-lg mb-1 capitalize">{item?.status}</h3>
                    <p className="leading-tight text-justify w-full text-sm">
                    {moment(item?.created).format('YY-MM-DD h:mm:ss A')}
                    </p>
                  </div>
                </div>
              ))}

            </div>
          </div>
        </div>
        <div className=''>
          <div className='text-sm md:text-xl'>
            Remarks
          </div>
          <div className='text-xs md:text-md'>
            {remarks?.results?.map((item: any, index: number) => (
              <article className="p-6 text-base bg-white border-t border-gray-200 dark:border-gray-700 dark:bg-gray-900" key={index}>
                <footer className="flex justify-between items-center mb-2">
                  <div className="flex items-center">
                    <div className='flex justify-start gap-x-2'>
                      <div className='h-8 w-8 md:w-12 md:h-12 rounded-full bg-gray-300 items-center justify-center flex'>
                        <p className='text-sm md:text-4xl text-primary'>{item?.user.is_staff ? "Danfe Staff".slice(0, 1) : item?.user?.name?.slice(0, 1)}</p>
                      </div>
                      <p className="inline-flex items-center mr-3 text-sm text-gray-900 dark:text-white">{item?.user.is_staff ? "Danfe Staff" : item?.user.name}</p>
                    </div>

                    <p className="text-sm text-gray-600 dark:text-gray-400">{moment(item?.created).format('YYYY-MM-DD hh:mm:ss A')}</p>
                  </div>
                </footer>
                <p className="text-gray-500 dark:text-gray-400 ml-14">{item?.remark}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default OrderHistory
